Oskari.lazyBundle('mydata', function() {return import(/* webpackChunkName: "chunk_mydata" */ 'oskari-bundle!oskari-frontend/bundles/framework/mydata/index.js');});
